export default __webpack_public_path__ + "static/media/copy_icon.48fedbba.svg";